import { QuestionSegmentProps } from '@/views/process/components/quizInialized/questions/QuestionSegment.model.ts';
import SegmentWrapper from '@/views/process/components/quizInialized/SegmentWrapper.tsx';
import { FC, useEffect, useRef, useState } from 'react';

interface Props extends QuestionSegmentProps {
  animationUrl?: string;
  audioUrl?: string;
  defaultFormVisible?: boolean;
  disabledButton?: boolean;
  hasNext?: boolean;
  muted?: boolean;
  onNext?: () => void;
  videoUrl?: string;
}

const QuestionWrapper: FC<Props> = ({
  defaultFormVisible,
  formComponent,
  hasNext,
  onNext,
  segmentContent,
  ...props
}) => {
  const [formVisible, setFormVisible] = useState(defaultFormVisible);
  const contentRef = useRef<HTMLDivElement>(null);

  const scrollToBottomSmooth = () => {
    if (contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToBottomSmooth();
  }, [formVisible]);

  const handleNext = () => {
    onNext?.();
    if (formComponent) {
      setFormVisible(true);
    }
  };

  return (
    <SegmentWrapper
      {...props}
      content={
        <>
          {segmentContent}
          {formVisible ? (
            <>
              {segmentContent && <div className="border-top border-light my-3"></div>}
              {formComponent && (
                <>
                  <div ref={contentRef} />
                  {formComponent}
                </>
              )}
            </>
          ) : null}
        </>
      }
      handleNext={handleNext}
      hasNext={hasNext ? hasNext : !formVisible}
    />
  );
};

export default QuestionWrapper;
